import React from 'react';
import {connect} from 'react-redux';
import {useTranslation} from "react-i18next";
import {AddButtonHeader} from "../../common/Button/Button";
import {getNmsNuixLicenceSourceIds} from '../../../reselect/selectors';
import NmsLicenceSourceRow from './NmsLicenceSourceRow';
import {applicationFeatures} from "../../../utilities/constants";
import {includesSome, isNotEmptyNorFalsy} from "../../../utilities/helperFunctions";
import LicenceSourceModel from "../../../models/settings/LicenceSourceModel";

const NmsLicenceSourceTable = props => {
    const {nmsLicenceSourceIds, showNmsLicenceSourceForm, userFeatures} = props;
    const {t} = useTranslation(['aria', 'nuixLicenceSource', 'common']);

    const canAddLicenceSource = includesSome(userFeatures, [applicationFeatures.ADD_RESOURCE, applicationFeatures.ADD_NUIX_LICENCE_SOURCE]);
    const isNotEmpty = isNotEmptyNorFalsy(nmsLicenceSourceIds);
    if (!canAddLicenceSource && !isNotEmpty) {
        return null;
    }

    return (
        <div className="display-item">
            <AddButtonHeader aria-label={t('aria:hiddenAssistText.addNmsLicenceSource')}
                text={t('nuixLicenceSource:label.nmsLicenceSourceName')}
                canModify={canAddLicenceSource} onClick={showNmsLicenceSourceForm}
            />

            {isNotEmpty &&
                <div className="display-table">
                    <div className="table-header-group">

                        <div className="table-header">
                            <label className="label is-bold">
                                {t('common:label.name')}
                            </label>
                        </div>

                        <div className="table-header">
                            <label className="label is-bold">
                                {t('nuixLicenceSource:label.filter')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('common:label.username')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('nuixLicenceSource:label.serverName')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('nuixLicenceSource:label.serverPort')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('nuixLicenceSource:label.relayType')}
                            </label>
                        </div>
                    </div>

                    <div className="table-row-group">
                        {nmsLicenceSourceIds.map(id =>
                            <NmsLicenceSourceRow key={id} nuixLicenceSourceId={id}/>
                        )}
                    </div>
                </div>
            }
        </div>
    );
}

const mapStateToProps = state => {
    return {
        nmsLicenceSourceIds: getNmsNuixLicenceSourceIds(state),
        userFeatures: state.currentUser.features
    };
}

const mapDispatchToProps = dispatch => {
    return {
        showNmsLicenceSourceForm: () => dispatch(LicenceSourceModel.componentActionCreators.updateDisplay({isNmsLicenceSourceFormActive: true}))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NmsLicenceSourceTable);